import { BodyText, Sidebar, SideNav, Stack, Tag } from '@servicetitan/design-system';
import { FC, Fragment, memo } from 'react';
import { Link, matchPath, useLocation } from 'react-router-dom';

import { InfoIcon } from '../../../../common/components/info-icon/info-icon';

import * as Styles from './styles.module.less';
import { SettingsNavGroup, SettingsNavItem, SettingsPageStructure } from '../../utils/types';

export function SettingsNavigation({ structure }: { structure: SettingsPageStructure }) {
    const location = useLocation();

    return (
        <Sidebar localStorageKey="sidebar-settings">
            <Sidebar.Section padding="y">
                <SideNav title={structure.title}>
                    {structure.navGroups.map(group => (
                        <Group key={group.key} group={group} pathname={location.pathname} />
                    ))}
                </SideNav>
            </Sidebar.Section>
        </Sidebar>
    );
}

const Group: FC<{
    group: SettingsNavGroup;
    pathname: string;
}> = ({ group, pathname }) => {
    return (
        <Fragment>
            {group.items.map(item => (
                <SettingNavItem pathName={pathname} item={item} key={item.title} />
            ))}
        </Fragment>
    );
};

const SettingNavItem: FC<{ item: SettingsNavItem; pathName: string }> = memo(
    ({ item, pathName }) => {
        const isActive = matchPath(pathName, {
            path: item.path,
        });
        const errorsBadge = !!item.numberOfErrors && (
            <Tag compact badge color="critical">
                {item.numberOfErrors}
            </Tag>
        );

        if (item.disabled) {
            return (
                <Stack className={Styles.disabledItem} key={item.path} disabled>
                    <BodyText size="small">{item.title}</BodyText>
                    {errorsBadge}
                </Stack>
            );
        }

        return (
            <Link to={item.path} key={item.title}>
                <SideNav.Item active={Boolean(isActive)}>
                    {item.title}
                    {!item.numberOfErrors && item.incomplete && (
                        <InfoIcon className={Styles.incompleteItem} />
                    )}
                    {errorsBadge}
                </SideNav.Item>
            </Link>
        );
    },
);
